export const validateLink = (url: URL, regexStr: string, errorEmbeddableLink: string, targetEmbedableUrl?: string) => {
    let link = url.toString();
    const regex = new RegExp(regexStr.replace("?", "[?]"));
    const matches = regex.exec(link);
    if (matches) {
        // if property has "targetEmbedableLink" transform the link to embedable link with regex
        if (targetEmbedableUrl) {
            link = targetEmbedableUrl.replace(/\$[0-9]+/g, (match) => {
                const index = parseInt(match.substring(1));
                return matches[index] ?? "";
            });
        }
    } else if (targetEmbedableUrl) {
        const targetPattern = targetEmbedableUrl
            .split(/(\$[0-9]+)/g)
            .map((part) =>
                /^\$[0-9]+$/.test(part) ? ".*" : part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            )
            .join("");
        if (!new RegExp(`^${targetPattern}$`).test(link)) {
            // If the link exists but is not an exact instance of the embed target template, there is an error.
            throw new Error(`${errorEmbeddableLink} (${regexStr})`);
        }
    } else {
        // If the link exists but is not the same of embedable link target, their is an error;
        throw new Error(`${errorEmbeddableLink} (${regexStr})`);
    }
    return link;
};
